import APIService from '@/services/APIService.js'

export default {
  getConciliacoes (includeExpiredRecords) {
    return APIService.apiCall().get(`/conciliacoes/getConciliacoes/${includeExpiredRecords}`)
  },
  getConciliacoesByStatus (status) {
    return APIService.apiCall().get(`/conciliacoes/getConciliacoesByStatus/${status}`)
  },
  getConciliacao (id) {
    return APIService.apiCall().get(`/conciliacoes/getConciliacao/${id}`)
  },
  salvarConciliacao (id, postData) {
    return APIService.apiCall().post(`/conciliacoes/salvar/${id}`, JSON.stringify(postData))
  },
  deletar (id) {
    return APIService.apiCall().get(`/conciliacoes/excluir/${id}`)
  },
  executar (id) {
    return APIService.apiCall().get(`/conciliacoes/executar/${id}`)
  },
  duplicar (id) {
    return APIService.apiCall().get(`/conciliacoes/duplicar/${id}`)
  },
  download (id, config = {}) {
    return APIService.apiCall().get(`/conciliacoes/baixarPlanilha/${id}`, { responseType: 'blob', ...config })
  },
  andamento (id) {
    return APIService.apiCall().get(`/conciliacoes/andamento/${id}`)
  },
  validaHeader (id, postData) {
    return APIService.apiCall().post(`/conciliacoes/validarHeader/${id}`, JSON.stringify(postData))
  },
  baixarArquivoModelo (tipoConciliacao) {
    return APIService.apiCall().get(`/conciliacoes/baixarArquivoModelo/${tipoConciliacao}`, { responseType: 'blob' })
  },
  downloadLogs (postData) {
    return APIService.apiCall().post('/conciliacoes/downloadLogs/', JSON.stringify(postData), {
      responseType: 'blob',
      ...{ timeout: 60 * 60 * 1000 },
    })
  },
  getEstimativaTempo (conciliacao) {
    return APIService.apiCall().post(`/conciliacoes/estimativaTempo`, conciliacao)
  },
}
